export const ORIENTATION_SHIFT_GREEN_COLOR = "#5EB174";
export const ORIENTATION_SHIFT_NAME = "ori";
